import PropTypes from 'prop-types';
import { Box, Container, Grid, Stack, Typography } from '@mui/material';

export default function StudioImageTextSection({
  id,
  eyebrow,
  title,
  body,
  imageSrc,
  imageAlt,
  imagePosition,
}) {
  const imageFirst = imagePosition === 'left';
  const hasImage = Boolean(imageSrc);

  return (
    <Box component="section" id={id || undefined} sx={{ py: { xs: 4, md: 8 } }}>
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
          {hasImage ? (
            <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: imageFirst ? 1 : 2 } }}>
              <Box
                component="img"
                src={imageSrc}
                alt={imageAlt || ''}
                sx={{ width: '100%', height: { xs: 280, md: 360 }, objectFit: 'cover' }}
              />
            </Grid>
          ) : null}
          <Grid
            item
            xs={12}
            md={hasImage ? 6 : 12}
            sx={{ order: { xs: 2, md: imageFirst ? 2 : 1 } }}
          >
            <Stack
              spacing={2}
              sx={{
                maxWidth: 560,
                mx: { md: hasImage && !imageFirst ? 'auto' : 0 },
                ml: { md: hasImage && imageFirst ? 2 : 0 },
              }}
            >
              {eyebrow ? (
                <Typography variant="subtitle2" sx={{ letterSpacing: 0.5 }}>
                  {eyebrow}
                </Typography>
              ) : null}
              <Typography
                component="h2"
                variant="h4"
                sx={{ fontWeight: 500, mt: eyebrow ? 0 : undefined }}
              >
                {title}
              </Typography>
              <Typography sx={{ lineHeight: 1.7 }}>{body}</Typography>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

StudioImageTextSection.propTypes = {
  id: PropTypes.string,
  eyebrow: PropTypes.string,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  imagePosition: PropTypes.oneOf(['left', 'right']),
};

StudioImageTextSection.defaultProps = {
  eyebrow: null,
  imageSrc: '',
  imageAlt: '',
  imagePosition: 'left',
};
